import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'
import { fetchLogisticsAmount } from '../../../actions/calculator'
import { InputWrapper, Label } from './Common'

const StyledSelect = styled(Select)`
  height: 48px;
  background: #F3F3F3 !important;

  .Select-control {
    font-size: 1.3em;
    background: #F3F3F3 !important;
    height: 48px;
    line-height: 48px;
    border-radius: 0;
    border: 0;

    .Select-value {
      line-height: 48px !important;
    }
  }

  .Select-menu-outer {
    margin-top: 15px !important;
  }

  .Select-input {
    height: 48px;
  }

  @media ${device.tablet} {
    width: 100%;
  ${''}
    height: 2.5vw;

    .Select-control {
      ${''}
      font-size: 1.09375vw;
      height: 2.5vw;
      line-height: 2.5vw;
      width: 100%;

      .Select-value {
        line-height: 2.5vw !important;
      }

      ${'' /* .Select-arrow-zone {
        width: 1.3020833333333335vw !important;
      } */}
    }

    .Select-menu-outer {
      margin-top: 0.78125vw !important;
      font-size: 1.09375vw;
    }

    .Select-input {
      height: 2.5vw;
    }
  }


`

class ReactSelect extends Component {
  constructor (props) {
    super(props)
    this.url = this.props.url
  }

  onChange (event) {
    if (this.props.input.onChange && event !== null) {
      // To be aligned with how redux-form publishes its CHANGE action payload. The event received is an object with 2 keys: "value" and "label"
      this.props.fetchLogisticsAmount(event.id)
      this.props.input.onChange(event.id)
    } else {
      // Clear the input field
      this.props.input.onChange(null)
    }
  }

  render () {
    return (
      <InputWrapper width={this.props.width} padding={this.props.padding}>
        <Label htmlFor={this.props.input.name}>{this.props.required ? `${this.props.label}*` : this.props.label}</Label>
        <StyledSelect
          {...this.props}
          value={this.props.input.value || ''}
          onBlur={() => this.props.input.onBlur(this.props.input.value)}
          onChange={this.onChange.bind(this)}
          placeholder=''
          valueKey={this.props.valueKey}
          labelKey={this.props.labelKey}
          options={this.props.options}
          noResultsText=''
        />
      </InputWrapper>
    )
  }
}

export default connect(null, { fetchLogisticsAmount })(ReactSelect)



// WEBPACK FOOTER //
// ./src/components/UI/Form/ReactSelect.js